// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
// import {
//   FaEdit,
//   FaSave,
//   FaTimes,
//   FaBan,
//   FaCheckCircle,
//   FaFileContract,
//   FaBold,
//   FaItalic,
//   FaUnderline,
//   FaListUl,
//   FaAlignLeft,
//   FaAlignCenter,
//   FaAlignRight,
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { PageHeader }      from '../../components/shared/PageHeader';
// import { SearchFilterBar } from '../../components/shared/SearchFilterBar';
// import { DataTable }       from '../../components/shared/DataTable';
// import { StatusSwitch }    from '../../components/shared/StatusSwitch';

// import { useEditor, EditorContent } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import Underline from '@tiptap/extension-underline';
// import TextAlign from '@tiptap/extension-text-align';
// import Link from '@tiptap/extension-link';

// const COLUMNS = ['Nome', 'Descrição', 'Última atualização', 'Status', 'Ações'];

// // const DEFAULT_TEMPLATE = `
// //   <h2 style="text-align: center;">Contrato de Veiculação de Mídia</h2>

// //   <p>
// //     Pelo presente instrumento particular, de um lado <strong>{{empresa.nome}}</strong>,
// //     inscrita no CNPJ sob o nº <strong>{{empresa.cnpj}}</strong>, com sede em
// //     <strong>{{empresa.endereco}}</strong>, doravante denominada <strong>CONTRATADA</strong>.
// //   </p>

// //   <p>
// //     De outro lado, <strong>{{cliente.nome}}</strong>, inscrito(a) no CPF/CNPJ sob o nº
// //     <strong>{{cliente.cnpj}}</strong>, com endereço em <strong>{{cliente.endereco}}</strong>,
// //     doravante denominado(a) <strong>CONTRATANTE</strong>.
// //   </p>

// //   <h3>1. Do Objeto</h3>

// //   <p>
// //     O presente contrato tem como objeto a veiculação de mídia publicitária em espaços de outdoor,
// //     painel, equipamento, tela ou ponto de mídia pertencente ou administrado pela CONTRATADA.
// //   </p>

// //   <h3>2. Do Plano Contratado</h3>

// //   <p>
// //     O CONTRATANTE contrata o plano <strong>{{plano.nome}}</strong>, com duração de
// //     <strong>{{plano.duracao}}</strong> <strong>{{plano.unidade}}</strong>, pelo valor de
// //     <strong>{{plano.valor}}</strong>.
// //   </p>

// //   <h3>3. Do Período de Veiculação</h3>

// //   <p>
// //     A veiculação terá início em <strong>{{pedido.data_inicio}}</strong> e término em
// //     <strong>{{pedido.data_fim}}</strong>.
// //   </p>

// //   <h3>4. Dos Locais de Veiculação</h3>

// //   <p>
// //     A mídia será veiculada nos seguintes pontos/equipamentos:
// //   </p>

// //   <p>
// //     <strong>{{equipamentos.lista}}</strong>
// //   </p>

// //   <h3>5. Do Valor e Condições de Pagamento</h3>

// //   <p>
// //     O valor total contratado é de <strong>{{pedido.valor_total}}</strong>.
// //     Havendo desconto, será aplicado o valor de <strong>{{pedido.desconto}}</strong>.
// //   </p>

// //   <h3>6. Das Obrigações do Contratante</h3>

// //   <p>
// //     O CONTRATANTE deverá fornecer a arte, material gráfico ou conteúdo publicitário em formato
// //     adequado e dentro do prazo necessário para instalação, exibição ou veiculação.
// //   </p>

// //   <h3>7. Das Obrigações da Contratada</h3>

// //   <p>
// //     A CONTRATADA se compromete a disponibilizar os espaços contratados conforme as condições
// //     estabelecidas neste instrumento, respeitando o período de veiculação contratado.
// //   </p>

// //   <h3>8. Disposições Gerais</h3>

// //   <p>
// //     As partes elegem o foro da comarca de <strong>{{empresa.cidade}}</strong> -
// //     <strong>{{empresa.estado}}</strong>, para dirimir quaisquer dúvidas oriundas deste contrato.
// //   </p>

// //   <p>
// //     E por estarem justas e contratadas, as partes assinam o presente contrato em formato físico
// //     ou eletrônico.
// //   </p>

// //   <br />
// //   <br />

// //   <p style="text-align: center;">
// //     {{empresa.cidade}}/{{empresa.estado}}, {{contrato.data_atual}}.
// //   </p>

// //   <br />
// //   <br />

// //   <p style="text-align: center;">
// //     _______________________________________<br />
// //     {{empresa.nome}}<br />
// //     CNPJ: {{empresa.cnpj}}
// //   </p>

// //   <br />

// //   <p style="text-align: center;">
// //     _______________________________________<br />
// //     {{cliente.nome}}<br />
// //     CPF/CNPJ: {{cliente.cnpj}}
// //   </p>
// // `;

// const DEFAULT_TEMPLATE = `
//   <h2 style="text-align: center;">CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE MÍDIA OUTDOOR</h2>

//   <br />

//   <p>
//     <strong>CONTRATADA:</strong> {{empresa.razao_social}}, inscrita no CNPJ sob nº
//     {{empresa.cnpj}}, com sede na {{empresa.endereco}}, {{empresa.cidade}} – {{empresa.estado}}.
//     Neste ato representada por seu representante legal, doravante denominada
//     <strong>CONTRATADA</strong>, com seu segmento de mídia comercialmente conhecido como
//     {{empresa.nome_fantasia}};
//   </p>

//   <p>
//     <strong>CONTRATANTE:</strong> {{cliente.nome}}, inscrito no CPF/CNPJ sob nº
//     {{cliente.cnpj}}, sediado em {{cliente.endereco}}, {{cliente.cidade}}/{{cliente.estado}},
//     doravante denominado <strong>CONTRATANTE</strong>;
//   </p>

//   <p>
//     Celebram o presente <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</strong>, mediante as
//     cláusulas seguintes:
//   </p>

//   <h3>CLÁUSULA 1 – DO OBJETO</h3>

//   <p>
//     O presente contrato tem como objeto a veiculação de mídia digital em outdoor, de acordo
//     com o plano contratado, conforme valores abaixo:
//   </p>

//   <p>
//     <strong>Pedido:</strong> {{pedido.codigo}}<br />
//     <strong>Plano:</strong> {{plano.nome}}<br />
//     <strong>Valor:</strong> {{pedido.valor_total}}
//   </p>

//   <p>
//     A veiculação será realizada em {{equipamentos.locais}}.<br />
//     {{equipamentos.lista}}
//   </p>

//   <p>
//     <em>Parágrafo único:</em> Os valores mencionados não incluem a criação de arte para o
//     anúncio, salvo contratação específica e adicional para tal serviço.
//   </p>

//   <h3>CLÁUSULA 2 – DAS CONDIÇÕES TÉCNICAS</h3>

//   <p>2.1. Cada anúncio será exibido com duração máxima de 15 (quinze) segundos.</p>

//   <p>
//     2.2. O outdoor funcionará diariamente no horário das 06h30 às 22h30, de domingo a
//     quinta-feira, e das 06h30 às 23h59min59s nas sextas-feiras e sábados, podendo esse
//     horário ser estendido a critério da CONTRATADA.
//   </p>

//   <p>
//     2.3. Problemas técnicos são suscetíveis de ocorrer, mas a CONTRATADA se compromete a
//     resolvê-los com a maior brevidade possível.
//   </p>

//   <p>
//     2.4. A CONTRATADA realizará manutenções preventivas e corretivas, podendo suspender
//     temporariamente a veiculação.
//   </p>

//   <h3>CLÁUSULA 3 – DO PAGAMENTO</h3>

//   <p>
//     O CONTRATANTE pagará à CONTRATADA o valor correspondente ao plano contratado, sendo
//     obrigatória a quitação da primeira parcela no ato da assinatura, a título de adesão.
//   </p>

//   <p>
//     <strong>Valor total:</strong> {{pedido.valor_total}}<br />
//     <strong>Desconto já aplicado em negociação:</strong> {{pedido.desconto}}
//   </p>

//   <p>O pagamento será realizado via Boleto Bancário.</p>

//   <p>
//     Em caso de atraso:<br />
//     Multa de 2% + juros de 1% ao mês (pro rata die).
//   </p>

//   <p>
//     <em>Parágrafo único:</em> Em caso de renovação automática, os valores poderão ser
//     reajustados conforme o índice IPCA.
//   </p>

//   <h3>CLÁUSULA 4 – DA VIGÊNCIA</h3>

//   <p>O presente contrato terá vigência conforme o plano contratado:</p>

//   <p>
//     <strong>Início:</strong> {{pedido.data_inicio}}<br />
//     <strong>Fim:</strong> {{pedido.data_fim}}
//   </p>

//   <p>
//     <em>Parágrafo único:</em> Caso não haja manifestação contrária até 5 dias antes do
//     término, o contrato será automaticamente renovado.
//   </p>

//   <h3>CLÁUSULA 5 – DA RESCISÃO</h3>

//   <p>
//     5.1. Em caso de rescisão antecipada pelo CONTRATANTE, será devida multa de 20% sobre o
//     saldo restante.
//   </p>

//   <p>5.2. O CONTRATANTE deverá notificar com antecedência mínima de 30 dias.</p>

//   <p>5.3. A CONTRATADA poderá rescindir por descumprimento contratual.</p>

//   <h3>CLÁUSULA 6 – DAS RESPONSABILIDADES E USO DE IMAGEM</h3>

//   <p>6.1. O conteúdo da propaganda é de responsabilidade do CONTRATANTE.</p>

//   <p>6.2. O CONTRATANTE declara possuir direitos sobre os materiais utilizados.</p>

//   <p>6.3. O CONTRATANTE indenizará a CONTRATADA por qualquer problema legal.</p>

//   <p>6.4. A CONTRATADA poderá recusar anúncios inadequados.</p>

//   <p>6.5. A arte deverá ser fornecida pelo CONTRATANTE, salvo contratação adicional.</p>

//   <h3>CLÁUSULA 7 – DO FORO</h3>

//   <p>Fica eleito o foro da Comarca de {{empresa.cidade}} - {{empresa.estado}}.</p>

//   <h3>CLÁUSULA 8 – DA REJEIÇÃO OU CANCELAMENTO</h3>

//   <p>8.1. A CONTRATADA poderá recusar ou cancelar anúncios que:</p>

//   <ul>
//     <li>Afetem sua imagem</li>
//     <li>Sejam inadequados</li>
//     <li>Gerem repercussão negativa</li>
//     <li>Não estejam alinhados ao perfil da mídia</li>
//   </ul>

//   <p>8.2. Nesses casos, haverá ressarcimento proporcional ao tempo não utilizado.</p>

//   <h3>CLÁUSULA 9 – DA CONFIDENCIALIDADE</h3>

//   <p>9.1. As partes manterão sigilo sobre informações estratégicas.</p>

//   <p>9.2. O sigilo permanecerá por 2 anos após o término.</p>

//   <h3>CLÁUSULA 10 – DOS DIREITOS AUTORAIS</h3>

//   <p>10.1. O CONTRATANTE declara possuir direitos sobre os conteúdos.</p>

//   <p>10.2. A CONTRATADA não se responsabiliza por uso indevido.</p>

//   <p>10.3. O CONTRATANTE indenizará eventuais prejuízos.</p>

//   <br />
//   <br />

//   <p style="text-align: right;">
//     {{empresa.cidade}} - {{empresa.estado}}, {{contrato.data_atual}}.
//   </p>

//   <br />
//   <br />
//   <br />

//   <p style="text-align: center;">
//     __________________________________________________<br />
//     <strong>{{empresa.razao_social}}</strong><br />
//     CNPJ/CPF: {{empresa.cnpj}}<br />
//     (Contratada - {{empresa.nome_fantasia}})
//   </p>

//   <br />
//   <br />

//   <p style="text-align: center;">
//     _________________________________________________<br />
//     <strong>{{cliente.nome}}</strong><br />
//     CNPJ/CPF: {{cliente.cnpj}}<br />
//     CONTRATANTE
//   </p>
// `;


// const VARIAVEIS = [
//   {
//     grupo: 'Cliente',
//     itens: [
//       { label: 'Nome do cliente', value: '{{cliente.nome}}' },
//       { label: 'CPF/CNPJ', value: '{{cliente.cnpj}}' },
//       { label: 'E-mail', value: '{{cliente.email}}' },
//       { label: 'Telefone', value: '{{cliente.telefone}}' },
//       { label: 'Endereço', value: '{{cliente.endereco}}' },
//       { label: 'Cidade', value: '{{cliente.cidade}}' },
//       { label: 'Estado', value: '{{cliente.estado}}' },
//       { label: 'Inscrição Municipal', value: '{{cliente.inscricao_municipal}}' },
//       { label: 'Inscrição Estadual', value: '{{cliente.inscricao_estadual}}' },
//     ],
//   },
//   {
//     grupo: 'Empresa',
//     itens: [
//       { label: 'Nome fantasia', value: '{{empresa.nome}}' },
//       { label: 'Razão social', value: '{{empresa.razao_social}}' },
//       { label: 'CNPJ', value: '{{empresa.cnpj}}' },
//       { label: 'E-mail', value: '{{empresa.email}}' },
//       { label: 'Telefone', value: '{{empresa.telefone}}' },
//       { label: 'Endereço', value: '{{empresa.endereco}}' },
//       { label: 'Cidade', value: '{{empresa.cidade}}' },
//       { label: 'Estado', value: '{{empresa.estado}}' },
//     ],
//   },
//   {
//     grupo: 'Plano de Mídia',
//     itens: [
//       { label: 'Nome do plano', value: '{{plano.nome}}' },
//       { label: 'Valor do plano', value: '{{plano.valor}}' },
//       { label: 'Duração', value: '{{plano.duracao}}' },
//       { label: 'Unidade', value: '{{plano.unidade}}' },
//     ],
//   },
//   {
//     grupo: 'Pedido',
//     itens: [
//       { label: 'Código do pedido', value: '{{pedido.codigo}}' },
//       { label: 'Data de início', value: '{{pedido.data_inicio}}' },
//       { label: 'Data de fim', value: '{{pedido.data_fim}}' },
//       { label: 'Status do pedido', value: '{{pedido.status}}' },
//       { label: 'Valor total', value: '{{pedido.valor_total}}' },
//       { label: 'Desconto', value: '{{pedido.desconto}}' },
//     ],
//   },
//   {
//     grupo: 'Serviço',
//     itens: [
//       { label: 'Nome do serviço', value: '{{servico.nome}}' },
//       { label: 'Descrição do serviço', value: '{{servico.descricao}}' },
//     ],
//   },
//   {
//     grupo: 'Equipamentos / Outdoors',
//     itens: [
//       { label: 'Lista de equipamentos', value: '{{equipamentos.lista}}' },
//       { label: 'Quantidade de equipamentos', value: '{{equipamentos.quantidade}}' },
//       { label: 'Locais de veiculação', value: '{{equipamentos.locais}}' },
//     ],
//   },
//   {
//     grupo: 'Contrato',
//     itens: [
//       { label: 'Data atual', value: '{{contrato.data_atual}}' },
//       { label: 'Código do contrato', value: '{{contrato.codigo}}' },
//     ],
//   },
// ];

// // ==========================================
// // PÁGINA PRINCIPAL
// // ==========================================
// export default function ModeloContratos() {
//   const [contratos,       setContratos]       = useState([]);
//   const [searchTerm,      setSearchTerm]      = useState('');
//   const [showModal,       setShowModal]       = useState(false);
//   const [currentContrato, setCurrentContrato] = useState(null);
//   const [loading,         setLoading]         = useState(true);

//   // ── Fetch ──
//   const fetchContratos = async () => {
//     try {
//       setLoading(true);

//       const res = await api.get('/contract-templates');

//       setContratos(res.data);
//     } catch (error) {
//       toast.error('Erro ao carregar os modelos de contrato.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchContratos();
//   }, []);

//   // ── Handlers ──
//   const handleSave = async (data) => {
//     try {
//       if (!data.name?.trim()) {
//         toast.error('Informe o nome do modelo.');
//         return;
//       }

//       if (!data.htmlContent?.trim()) {
//         toast.error('O conteúdo do contrato não pode ficar vazio.');
//         return;
//       }

//       const payload = {
//         name: data.name,
//         description: data.description,
//         htmlContent: data.htmlContent,
//         isActive: data.isActive,
//       };

//       if (data.id) {
//         await api.put(`/contract-templates/${data.id}`, payload);
//         toast.success('Modelo de contrato atualizado com sucesso!');
//       } else {
//         await api.post('/contract-templates', payload);
//         toast.success('Modelo de contrato cadastrado com sucesso!');
//       }

//       await fetchContratos();

//       setShowModal(false);
//       setCurrentContrato(null);
//     } catch (error) {
//       toast.error(error.response?.data?.error || 'Erro ao salvar o modelo de contrato.');
//     }
//   };

//   const handleToggleStatus = async (contrato) => {
//     const msg = contrato.isActive
//       ? 'Tem certeza que deseja INATIVAR este modelo de contrato?'
//       : 'Deseja ATIVAR este modelo de contrato novamente?';

//     if (!window.confirm(msg)) return;

//     try {
//       await api.put(`/contract-templates/${contrato.id}`, {
//         name: contrato.name,
//         description: contrato.description,
//         htmlContent: contrato.htmlContent || contrato.html_content,
//         isActive: !contrato.isActive,
//       });

//       toast.success(`Modelo ${contrato.isActive ? 'inativado' : 'ativado'} com sucesso!`);

//       await fetchContratos();
//     } catch (error) {
//       toast.error('Erro ao alterar o status do modelo.');
//     }
//   };

//   const handleNew = () => {
//     setCurrentContrato(null);
//     setShowModal(true);
//   };

//   const handleEdit = (contrato) => {
//     setCurrentContrato(contrato);
//     setShowModal(true);
//   };

//   // ── Filtro ──
//   const filtered = contratos.filter((contrato) => {
//     const term = searchTerm.toLowerCase();

//     return (
//       contrato.name?.toLowerCase().includes(term) ||
//       contrato.description?.toLowerCase().includes(term)
//     );
//   });

//   const formatDate = (date) => {
//     if (!date) return '-';

//     return new Date(date).toLocaleDateString('pt-BR', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//     });
//   };

//   return (
//     <Container fluid className="p-4">

//       <PageHeader
//         title="Modelos de Contrato"
//         buttonLabel="Novo Modelo"
//         onButtonClick={handleNew}
//       />

//       <SearchFilterBar
//         searchTerm={searchTerm}
//         onSearchChange={setSearchTerm}
//         searchPlaceholder="Buscar modelo por nome ou descrição..."
//       />

//       <DataTable
//         columns={COLUMNS}
//         loading={loading}
//         emptyMessage="Nenhum modelo de contrato encontrado."
//       >
//         {filtered.length > 0 && filtered.map((contrato) => (
//           <tr key={contrato.id}>
//             <td>
//               <div className="d-flex align-items-center gap-2">
//                 <FaFileContract className="text-primary" />
//                 <strong>{contrato.name}</strong>
//               </div>
//             </td>

//             <td>{contrato.description || '-'}</td>

//             <td>{formatDate(contrato.updatedAt || contrato.updated_at)}</td>

//             <td>
//               {contrato.isActive
//                 ? (
//                   <span className="text-success fw-bold">
//                     <FaCheckCircle className="me-1" />
//                     Ativo
//                   </span>
//                 )
//                 : (
//                   <span className="text-secondary fw-bold">
//                     <FaBan className="me-1" />
//                     Inativo
//                   </span>
//                 )}
//             </td>

//             <td>
//               <Button
//                 variant="warning"
//                 size="sm"
//                 className="me-2"
//                 onClick={() => handleEdit(contrato)}
//                 title="Editar Modelo"
//               >
//                 <FaEdit />
//               </Button>

//               <Button
//                 variant={contrato.isActive ? 'danger' : 'success'}
//                 size="sm"
//                 onClick={() => handleToggleStatus(contrato)}
//                 title={contrato.isActive ? 'Inativar Modelo' : 'Ativar Modelo'}
//               >
//                 {contrato.isActive ? <FaBan /> : <FaCheckCircle />}
//               </Button>
//             </td>
//           </tr>
//         ))}
//       </DataTable>

//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         size="xl"
//         backdrop="static"
//       >
//         <Modal.Body>
//           <ContratoForm
//             contrato={currentContrato}
//             onSave={handleSave}
//             onCancel={() => setShowModal(false)}
//           />
//         </Modal.Body>
//       </Modal>

//     </Container>
//   );
// }

// // ==========================================
// // FORMULÁRIO
// // ==========================================
// function ContratoForm({ contrato, onSave, onCancel }) {
//   const [formData, setFormData] = useState({
//     id: contrato?.id || null,
//     name: contrato?.name || '',
//     description: contrato?.description || '',
//     htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
//     isActive: contrato?.id ? contrato.isActive : true,
//   });

//   useEffect(() => {
//     setFormData({
//       id: contrato?.id || null,
//       name: contrato?.name || '',
//       description: contrato?.description || '',
//       htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
//       isActive: contrato?.id ? contrato.isActive : true,
//     });
//   }, [contrato]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditorChange = (html) => {
//     setFormData((prev) => ({
//       ...prev,
//       htmlContent: html,
//     }));
//   };

//   return (
//     <Card className="border-0">
//       <Card.Header className="bg-white d-flex justify-content-between align-items-center">
//         <h5 className="mb-0">
//           {contrato ? 'Editar Modelo de Contrato' : 'Novo Modelo de Contrato'}
//         </h5>

//         <StatusSwitch
//           value={formData.isActive}
//           onChange={(v) => setFormData((prev) => ({ ...prev, isActive: v }))}
//         />
//       </Card.Header>

//       <Card.Body>
//         <Form
//           onSubmit={(e) => {
//             e.preventDefault();
//             onSave(formData);
//           }}
//         >
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Nome do Modelo *</Form.Label>
//                 <Form.Control
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="Ex: Contrato Padrão de Veiculação Outdoor"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Descrição</Form.Label>
//                 <Form.Control
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   placeholder="Ex: Modelo usado para contratos de mídia externa"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Conteúdo do Contrato *</Form.Label>

//             <ContractEditor
//               value={formData.htmlContent}
//               onChange={handleEditorChange}
//             />
//           </Form.Group>

//           <hr />

//           <div className="d-flex justify-content-end gap-2 mt-3">
//             <Button variant="secondary" onClick={onCancel}>
//               <FaTimes className="me-1" />
//               Cancelar
//             </Button>

//             <Button variant="success" type="submit">
//               <FaSave className="me-2" />
//               Salvar
//             </Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// }

// // ==========================================
// // EDITOR TIPTAP
// // ==========================================
// function ContractEditor({ value, onChange }) {
//   const editor = useEditor({
//     extensions: [
//       StarterKit,
//       Underline,
//       Link.configure({
//         openOnClick: false,
//       }),
//       TextAlign.configure({
//         types: ['heading', 'paragraph'],
//       }),
//     ],
//     content: value || '',
//     onUpdate({ editor }) {
//       onChange(editor.getHTML());
//     },
//   });

//   useEffect(() => {
//     if (!editor) return;

//     const currentHtml = editor.getHTML();

//     if (value && value !== currentHtml) {
//       editor.commands.setContent(value);
//     }
//   }, [value, editor]);

//   if (!editor) {
//     return null;
//   }

//   const inserirVariavel = (variavel) => {
//     editor.chain().focus().insertContent(variavel).run();
//   };

//   return (
//     <div className="contract-editor-wrapper">
//       <Row className="g-0">
//         <Col md={9}>
//           <div className="contract-toolbar">
//             <Button
//               type="button"
//               variant={editor.isActive('bold') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleBold().run()}
//               title="Negrito"
//             >
//               <FaBold />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('italic') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleItalic().run()}
//               title="Itálico"
//             >
//               <FaItalic />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('underline') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleUnderline().run()}
//               title="Sublinhado"
//             >
//               <FaUnderline />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('heading', { level: 2 }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
//               title="Título"
//             >
//               Título
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('bulletList') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleBulletList().run()}
//               title="Lista"
//             >
//               <FaListUl />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'left' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('left').run()}
//               title="Alinhar à esquerda"
//             >
//               <FaAlignLeft />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'center' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('center').run()}
//               title="Centralizar"
//             >
//               <FaAlignCenter />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'right' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('right').run()}
//               title="Alinhar à direita"
//             >
//               <FaAlignRight />
//             </Button>
//           </div>

//           <div className="contract-editor">
//             <EditorContent editor={editor} />
//           </div>
//         </Col>

//         <Col md={3}>
//           <div className="contract-vars">
//             <h6 className="fw-bold mb-3">Variáveis disponíveis</h6>

//             {VARIAVEIS.map((grupo) => (
//               <div key={grupo.grupo} className="mb-3">
//                 <div className="text-muted fw-bold small mb-2">
//                   {grupo.grupo}
//                 </div>

//                 <div className="d-grid gap-2">
//                   {grupo.itens.map((item) => (
//                     <Button
//                       key={item.value}
//                       type="button"
//                       variant="outline-secondary"
//                       size="sm"
//                       className="text-start"
//                       onClick={() => inserirVariavel(item.value)}
//                       title={item.value}
//                     >
//                       {item.label}
//                     </Button>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </Col>
//       </Row>
//     </div>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
// import {
//   FaEdit,
//   FaSave,
//   FaTimes,
//   FaBan,
//   FaCheckCircle,
//   FaFileContract,
//   FaBold,
//   FaItalic,
//   FaUnderline,
//   FaListUl,
//   FaAlignLeft,
//   FaAlignCenter,
//   FaAlignRight,
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { PageHeader }      from '../../components/shared/PageHeader';
// import { SearchFilterBar } from '../../components/shared/SearchFilterBar';
// import { DataTable }       from '../../components/shared/DataTable';
// import { StatusSwitch }    from '../../components/shared/StatusSwitch';

// import { useEditor, EditorContent } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import Underline from '@tiptap/extension-underline';
// import TextAlign from '@tiptap/extension-text-align';
// import Link from '@tiptap/extension-link';

// // ✅ v3: named imports do pacote unificado de tabela
// import { Table, TableRow, TableCell, TableHeader } from '@tiptap/extension-table';

// const COLUMNS = ['Nome', 'Descrição', 'Última atualização', 'Status', 'Ações'];

// // ==========================================
// // BLOCOS HTML PRONTOS (reutilizáveis)
// // ==========================================
// const BLOCO_ASSINATURAS = `
// <table style="width: 100%; border-collapse: collapse; margin-top: 60px;">
//   <tbody>
//     <tr>
//       <td style="width: 50%; text-align: center; vertical-align: top; padding: 15px 30px;">
//         __________________________________<br />
//         <strong>{{empresa.razao_social}}</strong><br />
//         CNPJ/CPF: {{empresa.cnpj}}<br />
//         <span style="font-size: 11px; color: #555;">(Contratada - {{empresa.nome_fantasia}})</span>
//       </td>
//       <td style="width: 50%; text-align: center; vertical-align: top; padding: 15px 30px;">
//         __________________________________<br />
//         <strong>{{cliente.nome}}</strong><br />
//         CNPJ/CPF: {{cliente.cnpj}}<br />
//         <span style="font-size: 11px; color: #555;">(Contratante)</span>
//       </td>
//     </tr>
//   </tbody>
// </table>
// `;

// const BLOCO_EQUIPAMENTOS = `
// <table style="width: 100%; border-collapse: collapse; margin-top: 20px; margin-bottom: 20px;">
//   <thead>
//     <tr style="background-color: #f5f5f5;">
//       <th style="padding: 10px 12px; border: 1px solid #ddd; text-align: left;">Equipamento / Outdoor</th>
//       <th style="padding: 10px 12px; border: 1px solid #ddd; text-align: left;">Local de Veiculação</th>
//       <th style="padding: 10px 12px; border: 1px solid #ddd; text-align: center;">Qtd.</th>
//     </tr>
//   </thead>
//   <tbody>
//     {{equipamentos.linhas}}
//   </tbody>
// </table>
// `;


// const BLOCO_RESUMO_FINANCEIRO = `
// <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
//   <tbody>
//     <tr>
//       <td style="width: 50%; padding: 8px 12px; border: 1px solid #ddd;"><strong>Valor total</strong></td>
//       <td style="width: 50%; padding: 8px 12px; border: 1px solid #ddd;">{{pedido.valor_total}}</td>
//     </tr>
//     <tr>
//       <td style="padding: 8px 12px; border: 1px solid #ddd;"><strong>Desconto aplicado</strong></td>
//       <td style="padding: 8px 12px; border: 1px solid #ddd;">{{pedido.desconto}}</td>
//     </tr>
//     <tr>
//       <td style="padding: 8px 12px; border: 1px solid #ddd;"><strong>Plano contratado</strong></td>
//       <td style="padding: 8px 12px; border: 1px solid #ddd;">{{plano.nome}}</td>
//     </tr>
//   </tbody>
// </table>
// `;

// const DEFAULT_TEMPLATE = `
//   <h2 style="text-align: center;">CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE MÍDIA OUTDOOR</h2>

//   <br />

//   <p>
//     <strong>CONTRATADA:</strong> {{empresa.razao_social}}, inscrita no CNPJ sob nº
//     {{empresa.cnpj}}, com sede na {{empresa.endereco}}, {{empresa.cidade}} – {{empresa.estado}}.
//     Neste ato representada por seu representante legal, doravante denominada
//     <strong>CONTRATADA</strong>, com seu segmento de mídia comercialmente conhecido como
//     {{empresa.nome_fantasia}};
//   </p>

//   <p>
//     <strong>CONTRATANTE:</strong> {{cliente.nome}}, inscrito no CPF/CNPJ sob nº
//     {{cliente.cnpj}}, sediado em {{cliente.endereco}}, {{cliente.cidade}}/{{cliente.estado}},
//     doravante denominado <strong>CONTRATANTE</strong>;
//   </p>

//   <p>
//     Celebram o presente <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</strong>, mediante as
//     cláusulas seguintes:
//   </p>

//   <h3>CLÁUSULA 1 – DO OBJETO</h3>

//   <p>
//     O presente contrato tem como objeto a veiculação de mídia digital em outdoor, de acordo
//     com o plano contratado, conforme valores abaixo:
//   </p>

//   <p>
//     <strong>Pedido:</strong> {{pedido.codigo}}<br />
//     <strong>Plano:</strong> {{plano.nome}}<br />
//     <strong>Valor:</strong> {{pedido.valor_total}}
//   </p>

//     ${BLOCO_EQUIPAMENTOS}

//   <p>
//     <em>Parágrafo único:</em> Os valores mencionados não incluem a criação de arte para o
//     anúncio, salvo contratação específica e adicional para tal serviço.
//   </p>

//   <h3>CLÁUSULA 2 – DAS CONDIÇÕES TÉCNICAS</h3>

//   <p>2.1. Cada anúncio será exibido com duração máxima de 15 (quinze) segundos.</p>

//   <p>
//     2.2. O outdoor funcionará diariamente no horário das 06h30 às 22h30, de domingo a
//     quinta-feira, e das 06h30 às 23h59min59s nas sextas-feiras e sábados, podendo esse
//     horário ser estendido a critério da CONTRATADA.
//   </p>

//   <p>
//     2.3. Problemas técnicos são suscetíveis de ocorrer, mas a CONTRATADA se compromete a
//     resolvê-los com a maior brevidade possível.
//   </p>

//   <p>
//     2.4. A CONTRATADA realizará manutenções preventivas e corretivas, podendo suspender
//     temporariamente a veiculação.
//   </p>

//   <h3>CLÁUSULA 3 – DO PAGAMENTO</h3>

//   <p>
//     O CONTRATANTE pagará à CONTRATADA o valor correspondente ao plano contratado, sendo
//     obrigatória a quitação da primeira parcela no ato da assinatura, a título de adesão.
//   </p>

//   <p>
//     <strong>Valor total:</strong> {{pedido.valor_total}}<br />
//     <strong>Desconto já aplicado em negociação:</strong> {{pedido.desconto}}
//   </p>

//   <p>O pagamento será realizado via Boleto Bancário.</p>

//   <p>
//     Em caso de atraso:<br />
//     Multa de 2% + juros de 1% ao mês (pro rata die).
//   </p>

//   <p>
//     <em>Parágrafo único:</em> Em caso de renovação automática, os valores poderão ser
//     reajustados conforme o índice IPCA.
//   </p>

//   <h3>CLÁUSULA 4 – DA VIGÊNCIA</h3>

//   <p>O presente contrato terá vigência conforme o plano contratado:</p>

//   <p>
//     <strong>Início:</strong> {{pedido.data_inicio}}<br />
//     <strong>Fim:</strong> {{pedido.data_fim}}
//   </p>

//   <p>
//     <em>Parágrafo único:</em> Caso não haja manifestação contrária até 5 dias antes do
//     término, o contrato será automaticamente renovado.
//   </p>

//   <h3>CLÁUSULA 5 – DA RESCISÃO</h3>

//   <p>
//     5.1. Em caso de rescisão antecipada pelo CONTRATANTE, será devida multa de 20% sobre o
//     saldo restante.
//   </p>

//   <p>5.2. O CONTRATANTE deverá notificar com antecedência mínima de 30 dias.</p>

//   <p>5.3. A CONTRATADA poderá rescindir por descumprimento contratual.</p>

//   <h3>CLÁUSULA 6 – DAS RESPONSABILIDADES E USO DE IMAGEM</h3>

//   <p>6.1. O conteúdo da propaganda é de responsabilidade do CONTRATANTE.</p>

//   <p>6.2. O CONTRATANTE declara possuir direitos sobre os materiais utilizados.</p>

//   <p>6.3. O CONTRATANTE indenizará a CONTRATADA por qualquer problema legal.</p>

//   <p>6.4. A CONTRATADA poderá recusar anúncios inadequados.</p>

//   <p>6.5. A arte deverá ser fornecida pelo CONTRATANTE, salvo contratação adicional.</p>

//   <h3>CLÁUSULA 7 – DO FORO</h3>

//   <p>Fica eleito o foro da Comarca de {{empresa.cidade}} - {{empresa.estado}}.</p>

//   <h3>CLÁUSULA 8 – DA REJEIÇÃO OU CANCELAMENTO</h3>

//   <p>8.1. A CONTRATADA poderá recusar ou cancelar anúncios que:</p>

//   <ul>
//     <li>Afetem sua imagem</li>
//     <li>Sejam inadequados</li>
//     <li>Gerem repercussão negativa</li>
//     <li>Não estejam alinhados ao perfil da mídia</li>
//   </ul>

//   <p>8.2. Nesses casos, haverá ressarcimento proporcional ao tempo não utilizado.</p>

//   <h3>CLÁUSULA 9 – DA CONFIDENCIALIDADE</h3>

//   <p>9.1. As partes manterão sigilo sobre informações estratégicas.</p>

//   <p>9.2. O sigilo permanecerá por 2 anos após o término.</p>

//   <h3>CLÁUSULA 10 – DOS DIREITOS AUTORAIS</h3>

//   <p>10.1. O CONTRATANTE declara possuir direitos sobre os conteúdos.</p>

//   <p>10.2. A CONTRATADA não se responsabiliza por uso indevido.</p>

//   <p>10.3. O CONTRATANTE indenizará eventuais prejuízos.</p>

//   <br />
//   <br />

//   <p style="text-align: right;">
//     {{empresa.cidade}} - {{empresa.estado}}, {{contrato.data_atual}}.
//   </p>

//   <br />
//   <br />
//   <br />

//   ${BLOCO_ASSINATURAS}
// `;

// const VARIAVEIS = [
//   {
//     grupo: 'Cliente',
//     itens: [
//       { label: 'Nome do cliente', value: '{{cliente.nome}}' },
//       { label: 'CPF/CNPJ', value: '{{cliente.cnpj}}' },
//       { label: 'E-mail', value: '{{cliente.email}}' },
//       { label: 'Telefone', value: '{{cliente.telefone}}' },
//       { label: 'Endereço', value: '{{cliente.endereco}}' },
//       { label: 'Cidade', value: '{{cliente.cidade}}' },
//       { label: 'Estado', value: '{{cliente.estado}}' },
//       { label: 'Inscrição Municipal', value: '{{cliente.inscricao_municipal}}' },
//       { label: 'Inscrição Estadual', value: '{{cliente.inscricao_estadual}}' },
//     ],
//   },
//   {
//     grupo: 'Empresa',
//     itens: [
//       { label: 'Nome fantasia', value: '{{empresa.nome}}' },
//       { label: 'Razão social', value: '{{empresa.razao_social}}' },
//       { label: 'CNPJ', value: '{{empresa.cnpj}}' },
//       { label: 'E-mail', value: '{{empresa.email}}' },
//       { label: 'Telefone', value: '{{empresa.telefone}}' },
//       { label: 'Endereço', value: '{{empresa.endereco}}' },
//       { label: 'Cidade', value: '{{empresa.cidade}}' },
//       { label: 'Estado', value: '{{empresa.estado}}' },
//     ],
//   },
//   {
//     grupo: 'Plano de Mídia',
//     itens: [
//       { label: 'Nome do plano', value: '{{plano.nome}}' },
//       { label: 'Valor do plano', value: '{{plano.valor}}' },
//       { label: 'Duração', value: '{{plano.duracao}}' },
//       { label: 'Unidade', value: '{{plano.unidade}}' },
//     ],
//   },
//   {
//     grupo: 'Pedido',
//     itens: [
//       { label: 'Código do pedido', value: '{{pedido.codigo}}' },
//       { label: 'Data de início', value: '{{pedido.data_inicio}}' },
//       { label: 'Data de fim', value: '{{pedido.data_fim}}' },
//       { label: 'Status do pedido', value: '{{pedido.status}}' },
//       { label: 'Valor total', value: '{{pedido.valor_total}}' },
//       { label: 'Desconto', value: '{{pedido.desconto}}' },
//     ],
//   },
//   {
//     grupo: 'Serviço',
//     itens: [
//       { label: 'Nome do serviço', value: '{{servico.nome}}' },
//       { label: 'Descrição do serviço', value: '{{servico.descricao}}' },
//     ],
//   },
//   {
//     grupo: 'Equipamentos / Outdoors',
//     itens: [
//       { label: 'Lista de equipamentos', value: '{{equipamentos.lista}}' },
//       { label: 'Quantidade de equipamentos', value: '{{equipamentos.quantidade}}' },
//       { label: 'Locais de veiculação', value: '{{equipamentos.locais}}' },
//     ],
//   },
//   {
//     grupo: 'Contrato',
//     itens: [
//       { label: 'Data atual', value: '{{contrato.data_atual}}' },
//       { label: 'Código do contrato', value: '{{contrato.codigo}}' },
//     ],
//   },
//   {
//     grupo: 'Blocos Prontos',
//     itens: [
//       { label: '✍️ Bloco de Assinaturas', value: BLOCO_ASSINATURAS, html: true },
//       { label: '💰 Resumo Financeiro', value: BLOCO_RESUMO_FINANCEIRO, html: true },
//       { label: '📡 Tabela de Equipamentos', value: BLOCO_EQUIPAMENTOS, html: true },

//     ],
//   },
// ];

// // ==========================================
// // PÁGINA PRINCIPAL
// // ==========================================
// export default function ModeloContratos() {
//   const [contratos,       setContratos]       = useState([]);
//   const [searchTerm,      setSearchTerm]      = useState('');
//   const [showModal,       setShowModal]       = useState(false);
//   const [currentContrato, setCurrentContrato] = useState(null);
//   const [loading,         setLoading]         = useState(true);

//   // ── Fetch ──
//   const fetchContratos = async () => {
//     try {
//       setLoading(true);

//       const res = await api.get('/contract-templates');

//       setContratos(res.data);
//     } catch (error) {
//       toast.error('Erro ao carregar os modelos de contrato.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchContratos();
//   }, []);

//   // ── Handlers ──
//   const handleSave = async (data) => {
//     try {
//       if (!data.name?.trim()) {
//         toast.error('Informe o nome do modelo.');
//         return;
//       }

//       if (!data.htmlContent?.trim()) {
//         toast.error('O conteúdo do contrato não pode ficar vazio.');
//         return;
//       }

//       const payload = {
//         name: data.name,
//         description: data.description,
//         htmlContent: data.htmlContent,
//         isActive: data.isActive,
//       };

//       if (data.id) {
//         await api.put(`/contract-templates/${data.id}`, payload);
//         toast.success('Modelo de contrato atualizado com sucesso!');
//       } else {
//         await api.post('/contract-templates', payload);
//         toast.success('Modelo de contrato cadastrado com sucesso!');
//       }

//       await fetchContratos();

//       setShowModal(false);
//       setCurrentContrato(null);
//     } catch (error) {
//       toast.error(error.response?.data?.error || 'Erro ao salvar o modelo de contrato.');
//     }
//   };

//   const handleToggleStatus = async (contrato) => {
//     const msg = contrato.isActive
//       ? 'Tem certeza que deseja INATIVAR este modelo de contrato?'
//       : 'Deseja ATIVAR este modelo de contrato novamente?';

//     if (!window.confirm(msg)) return;

//     try {
//       await api.put(`/contract-templates/${contrato.id}`, {
//         name: contrato.name,
//         description: contrato.description,
//         htmlContent: contrato.htmlContent || contrato.html_content,
//         isActive: !contrato.isActive,
//       });

//       toast.success(`Modelo ${contrato.isActive ? 'inativado' : 'ativado'} com sucesso!`);

//       await fetchContratos();
//     } catch (error) {
//       toast.error('Erro ao alterar o status do modelo.');
//     }
//   };

//   const handleNew = () => {
//     setCurrentContrato(null);
//     setShowModal(true);
//   };

//   const handleEdit = (contrato) => {
//     setCurrentContrato(contrato);
//     setShowModal(true);
//   };

//   // ── Filtro ──
//   const filtered = contratos.filter((contrato) => {
//     const term = searchTerm.toLowerCase();

//     return (
//       contrato.name?.toLowerCase().includes(term) ||
//       contrato.description?.toLowerCase().includes(term)
//     );
//   });

//   const formatDate = (date) => {
//     if (!date) return '-';

//     return new Date(date).toLocaleDateString('pt-BR', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//     });
//   };

//   return (
//     <Container fluid className="p-4">

//       <PageHeader
//         title="Modelos de Contrato"
//         buttonLabel="Novo Modelo"
//         onButtonClick={handleNew}
//       />

//       <SearchFilterBar
//         searchTerm={searchTerm}
//         onSearchChange={setSearchTerm}
//         searchPlaceholder="Buscar modelo por nome ou descrição..."
//       />

//       <DataTable
//         columns={COLUMNS}
//         loading={loading}
//         emptyMessage="Nenhum modelo de contrato encontrado."
//       >
//         {filtered.length > 0 && filtered.map((contrato) => (
//           <tr key={contrato.id}>
//             <td>
//               <div className="d-flex align-items-center gap-2">
//                 <FaFileContract className="text-primary" />
//                 <strong>{contrato.name}</strong>
//               </div>
//             </td>

//             <td>{contrato.description || '-'}</td>

//             <td>{formatDate(contrato.updatedAt || contrato.updated_at)}</td>

//             <td>
//               {contrato.isActive
//                 ? (
//                   <span className="text-success fw-bold">
//                     <FaCheckCircle className="me-1" />
//                     Ativo
//                   </span>
//                 )
//                 : (
//                   <span className="text-secondary fw-bold">
//                     <FaBan className="me-1" />
//                     Inativo
//                   </span>
//                 )}
//             </td>

//             <td>
//               <Button
//                 variant="warning"
//                 size="sm"
//                 className="me-2"
//                 onClick={() => handleEdit(contrato)}
//                 title="Editar Modelo"
//               >
//                 <FaEdit />
//               </Button>

//               <Button
//                 variant={contrato.isActive ? 'danger' : 'success'}
//                 size="sm"
//                 onClick={() => handleToggleStatus(contrato)}
//                 title={contrato.isActive ? 'Inativar Modelo' : 'Ativar Modelo'}
//               >
//                 {contrato.isActive ? <FaBan /> : <FaCheckCircle />}
//               </Button>
//             </td>
//           </tr>
//         ))}
//       </DataTable>

//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         size="xl"
//         backdrop="static"
//       >
//         <Modal.Body>
//           <ContratoForm
//             contrato={currentContrato}
//             onSave={handleSave}
//             onCancel={() => setShowModal(false)}
//           />
//         </Modal.Body>
//       </Modal>

//     </Container>
//   );
// }

// // ==========================================
// // FORMULÁRIO
// // ==========================================
// function ContratoForm({ contrato, onSave, onCancel }) {
//   const [formData, setFormData] = useState({
//     id: contrato?.id || null,
//     name: contrato?.name || '',
//     description: contrato?.description || '',
//     htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
//     isActive: contrato?.id ? contrato.isActive : true,
//   });

//   useEffect(() => {
//     setFormData({
//       id: contrato?.id || null,
//       name: contrato?.name || '',
//       description: contrato?.description || '',
//       htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
//       isActive: contrato?.id ? contrato.isActive : true,
//     });
//   }, [contrato]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditorChange = (html) => {
//     setFormData((prev) => ({
//       ...prev,
//       htmlContent: html,
//     }));
//   };

//   return (
//     <Card className="border-0">
//       <Card.Header className="bg-white d-flex justify-content-between align-items-center">
//         <h5 className="mb-0">
//           {contrato ? 'Editar Modelo de Contrato' : 'Novo Modelo de Contrato'}
//         </h5>

//         <StatusSwitch
//           value={formData.isActive}
//           onChange={(v) => setFormData((prev) => ({ ...prev, isActive: v }))}
//         />
//       </Card.Header>

//       <Card.Body>
//         <Form
//           onSubmit={(e) => {
//             e.preventDefault();
//             onSave(formData);
//           }}
//         >
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Nome do Modelo *</Form.Label>
//                 <Form.Control
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="Ex: Contrato Padrão de Veiculação Outdoor"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Descrição</Form.Label>
//                 <Form.Control
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   placeholder="Ex: Modelo usado para contratos de mídia externa"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Conteúdo do Contrato *</Form.Label>

//             <ContractEditor
//               value={formData.htmlContent}
//               onChange={handleEditorChange}
//             />
//           </Form.Group>

//           <hr />

//           <div className="d-flex justify-content-end gap-2 mt-3">
//             <Button variant="secondary" onClick={onCancel}>
//               <FaTimes className="me-1" />
//               Cancelar
//             </Button>

//             <Button variant="success" type="submit">
//               <FaSave className="me-2" />
//               Salvar
//             </Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// }

// // ==========================================
// // EDITOR TIPTAP
// // ==========================================
// function ContractEditor({ value, onChange }) {
//   const editor = useEditor({
//     extensions: [
//       StarterKit,
//       Underline,
//       Link.configure({
//         openOnClick: false,
//       }),
//       TextAlign.configure({
//         types: ['heading', 'paragraph'],
//       }),
//       Table.configure({
//         resizable: false,
//         HTMLAttributes: {
//           style: 'width: 100%; border-collapse: collapse;',
//         },
//       }),
//       TableRow,
//       TableHeader,
//       TableCell,
//     ].filter(Boolean),
//     content: value || '',
//     onUpdate({ editor }) {
//       onChange(editor.getHTML());
//     },
//   });

//   useEffect(() => {
//     if (!editor) return;

//     const currentHtml = editor.getHTML();

//     if (value && value !== currentHtml) {
//       editor.commands.setContent(value);
//     }
//   }, [value, editor]);

//   if (!editor) {
//     return null;
//   }

//   // ✅ Agora recebe o ITEM inteiro (objeto) e diferencia texto de HTML
//   const inserirVariavel = (item) => {
//     const conteudo = typeof item === 'string' ? item : item.value;
//     const isHtml = typeof item === 'object' && item.html;

//     if (isHtml) {
//       // Insere HTML parseado como nós reais do editor (tabela, etc.)
//       editor
//         .chain()
//         .focus()
//         .insertContent(conteudo, {
//           parseOptions: { preserveWhitespace: false },
//         })
//         .run();
//     } else {
//       // Variável de texto simples
//       editor.chain().focus().insertContent(conteudo).run();
//     }
//   };

//   return (
//     <div className="contract-editor-wrapper">
//       <Row className="g-0">
//         <Col md={9}>
//           <div className="contract-toolbar">
//             <Button
//               type="button"
//               variant={editor.isActive('bold') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleBold().run()}
//               title="Negrito"
//             >
//               <FaBold />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('italic') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleItalic().run()}
//               title="Itálico"
//             >
//               <FaItalic />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('underline') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleUnderline().run()}
//               title="Sublinhado"
//             >
//               <FaUnderline />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('heading', { level: 2 }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
//               title="Título"
//             >
//               Título
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive('bulletList') ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().toggleBulletList().run()}
//               title="Lista"
//             >
//               <FaListUl />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'left' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('left').run()}
//               title="Alinhar à esquerda"
//             >
//               <FaAlignLeft />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'center' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('center').run()}
//               title="Centralizar"
//             >
//               <FaAlignCenter />
//             </Button>

//             <Button
//               type="button"
//               variant={editor.isActive({ textAlign: 'right' }) ? 'primary' : 'light'}
//               size="sm"
//               onClick={() => editor.chain().focus().setTextAlign('right').run()}
//               title="Alinhar à direita"
//             >
//               <FaAlignRight />
//             </Button>
//           </div>

//           <div className="contract-editor">
//             <EditorContent editor={editor} />
//           </div>
//         </Col>

//         <Col md={3}>
//           <div className="contract-vars">
//             <h6 className="fw-bold mb-3">Variáveis disponíveis</h6>

//             {VARIAVEIS.map((grupo) => (
//               <div key={grupo.grupo} className="mb-3">
//                 <div className="text-muted fw-bold small mb-2">
//                   {grupo.grupo}
//                 </div>

//                 <div className="d-grid gap-2">
//                   {grupo.itens.map((item) => (
//                     <Button
//                       key={item.label}
//                       type="button"
//                       variant={item.html ? 'outline-primary' : 'outline-secondary'}
//                       size="sm"
//                       className="text-start"
//                       onClick={() => inserirVariavel(item)}
//                       title={item.html ? 'Insere um bloco pronto' : item.value}
//                     >
//                       {item.label}
//                     </Button>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </Col>
//       </Row>
//     </div>
//   );
// }



import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import {
  FaEdit,
  FaSave,
  FaTimes,
  FaBan,
  FaCheckCircle,
  FaFileContract,
  FaBold,
  FaItalic,
  FaUnderline,
  FaListUl,
  FaAlignLeft,
  FaAlignCenter,
  FaAlignRight,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';

import { PageHeader }      from '../../components/shared/PageHeader';
import { SearchFilterBar } from '../../components/shared/SearchFilterBar';
import { DataTable }       from '../../components/shared/DataTable';
import { StatusSwitch }    from '../../components/shared/StatusSwitch';

import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Link from '@tiptap/extension-link';

// ✅ v3: named imports do pacote unificado de tabela
import { Table, TableRow, TableCell, TableHeader } from '@tiptap/extension-table';

const COLUMNS = ['Nome', 'Descrição', 'Última atualização', 'Status', 'Ações'];

// ==========================================
// BLOCOS HTML PRONTOS (reutilizáveis no editor)
// ==========================================

const BLOCO_ASSINATURAS = `
<table style="width: 100%; border-collapse: collapse; margin-top: 60px;">
  <tbody>
    <tr>
      <td style="width: 50%; text-align: center; vertical-align: top; padding: 15px 30px;">
        __________________________________<br />
        <strong>{{empresa.razao_social}}</strong><br />
        CNPJ/CPF: {{empresa.cnpj}}<br />
        <span style="font-size: 11px; color: #555;">(Contratada - {{empresa.nome}})</span>
      </td>
      <td style="width: 50%; text-align: center; vertical-align: top; padding: 15px 30px;">
        __________________________________<br />
        <strong>{{cliente.nome}}</strong><br />
        CNPJ/CPF: {{cliente.cnpj}}<br />
        <span style="font-size: 11px; color: #555;">(Contratante)</span>
      </td>
    </tr>
  </tbody>
</table>
`;

// ✅ Parágrafo isolado com o placeholder.
//    O BACKEND (renderContractTemplate) troca isso pela tabela inteira.
const BLOCO_EQUIPAMENTOS = `<p>{{equipamentos.tabela}}</p>`;

const BLOCO_RESUMO_FINANCEIRO = `
<table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
  <tbody>
    <tr>
      <td style="width: 50%; padding: 8px 12px; border: 1px solid #ddd;"><strong>Valor total</strong></td>
      <td style="width: 50%; padding: 8px 12px; border: 1px solid #ddd;">{{pedido.valor_total}}</td>
    </tr>
    <tr>
      <td style="padding: 8px 12px; border: 1px solid #ddd;"><strong>Desconto aplicado</strong></td>
      <td style="padding: 8px 12px; border: 1px solid #ddd;">{{pedido.desconto}}</td>
    </tr>
    <tr>
      <td style="padding: 8px 12px; border: 1px solid #ddd;"><strong>Plano contratado</strong></td>
      <td style="padding: 8px 12px; border: 1px solid #ddd;">{{plano.nome}}</td>
    </tr>
  </tbody>
</table>
`;

const DEFAULT_TEMPLATE = `
  <h2 style="text-align: center;">CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE MÍDIA OUTDOOR</h2>

  <br />

  <p>
    <strong>CONTRATADA:</strong> {{empresa.razao_social}}, inscrita no CNPJ sob nº
    {{empresa.cnpj}}, com sede na {{empresa.endereco}}, {{empresa.cidade}} – {{empresa.estado}}.
    Neste ato representada por seu representante legal, doravante denominada
    <strong>CONTRATADA</strong>, com seu segmento de mídia comercialmente conhecido como
    {{empresa.nome}};
  </p>

  <p>
    <strong>CONTRATANTE:</strong> {{cliente.nome}}, inscrito no CPF/CNPJ sob nº
    {{cliente.cnpj}}, sediado em {{cliente.endereco}}, {{cliente.cidade}}/{{cliente.estado}},
    doravante denominado <strong>CONTRATANTE</strong>;
  </p>

  <p>
    Celebram o presente <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</strong>, mediante as
    cláusulas seguintes:
  </p>

  <h3>CLÁUSULA 1 – DO OBJETO</h3>

  <p>
    O presente contrato tem como objeto a veiculação de mídia digital em outdoor, de acordo
    com o plano contratado, conforme valores abaixo:
  </p>

  <p>
    <strong>Pedido:</strong> {{pedido.codigo}}<br />
    <strong>Plano:</strong> {{plano.nome}}<br />
    <strong>Valor:</strong> {{pedido.valor_total}}
  </p>

  ${BLOCO_EQUIPAMENTOS}

  <p>
    <em>Parágrafo único:</em> Os valores mencionados não incluem a criação de arte para o
    anúncio, salvo contratação específica e adicional para tal serviço.
  </p>

  <h3>CLÁUSULA 2 – DAS CONDIÇÕES TÉCNICAS</h3>

  <p>2.1. Cada anúncio será exibido com duração máxima de 15 (quinze) segundos.</p>

  <p>
    2.2. O outdoor funcionará diariamente no horário das 06h30 às 22h30, de domingo a
    quinta-feira, e das 06h30 às 23h59min59s nas sextas-feiras e sábados, podendo esse
    horário ser estendido a critério da CONTRATADA.
  </p>

  <p>
    2.3. Problemas técnicos são suscetíveis de ocorrer, mas a CONTRATADA se compromete a
    resolvê-los com a maior brevidade possível.
  </p>

  <p>
    2.4. A CONTRATADA realizará manutenções preventivas e corretivas, podendo suspender
    temporariamente a veiculação.
  </p>

  <h3>CLÁUSULA 3 – DO PAGAMENTO</h3>

  <p>
    O CONTRATANTE pagará à CONTRATADA o valor correspondente ao plano contratado, sendo
    obrigatória a quitação da primeira parcela no ato da assinatura, a título de adesão.
  </p>

  <p>
    <strong>Valor total:</strong> {{pedido.valor_total}}<br />
    <strong>Desconto já aplicado em negociação:</strong> {{pedido.desconto}}
  </p>

  <p>O pagamento será realizado via Boleto Bancário.</p>

  <p>
    Em caso de atraso:<br />
    Multa de 2% + juros de 1% ao mês (pro rata die).
  </p>

  <p>
    <em>Parágrafo único:</em> Em caso de renovação automática, os valores poderão ser
    reajustados conforme o índice IPCA.
  </p>

  <h3>CLÁUSULA 4 – DA VIGÊNCIA</h3>

  <p>O presente contrato terá vigência conforme o plano contratado:</p>

  <p>
    <strong>Início:</strong> {{pedido.data_inicio}}<br />
    <strong>Fim:</strong> {{pedido.data_fim}}
  </p>

  <p>
    <em>Parágrafo único:</em> Caso não haja manifestação contrária até 5 dias antes do
    término, o contrato será automaticamente renovado.
  </p>

  <h3>CLÁUSULA 5 – DA RESCISÃO</h3>

  <p>
    5.1. Em caso de rescisão antecipada pelo CONTRATANTE, será devida multa de 20% sobre o
    saldo restante.
  </p>

  <p>5.2. O CONTRATANTE deverá notificar com antecedência mínima de 30 dias.</p>

  <p>5.3. A CONTRATADA poderá rescindir por descumprimento contratual.</p>

  <h3>CLÁUSULA 6 – DAS RESPONSABILIDADES E USO DE IMAGEM</h3>

  <p>6.1. O conteúdo da propaganda é de responsabilidade do CONTRATANTE.</p>

  <p>6.2. O CONTRATANTE declara possuir direitos sobre os materiais utilizados.</p>

  <p>6.3. O CONTRATANTE indenizará a CONTRATADA por qualquer problema legal.</p>

  <p>6.4. A CONTRATADA poderá recusar anúncios inadequados.</p>

  <p>6.5. A arte deverá ser fornecida pelo CONTRATANTE, salvo contratação adicional.</p>

  <h3>CLÁUSULA 7 – DO FORO</h3>

  <p>Fica eleito o foro da Comarca de {{empresa.cidade}} - {{empresa.estado}}.</p>

  <h3>CLÁUSULA 8 – DA REJEIÇÃO OU CANCELAMENTO</h3>

  <p>8.1. A CONTRATADA poderá recusar ou cancelar anúncios que:</p>

  <ul>
    <li>Afetem sua imagem</li>
    <li>Sejam inadequados</li>
    <li>Gerem repercussão negativa</li>
    <li>Não estejam alinhados ao perfil da mídia</li>
  </ul>

  <p>8.2. Nesses casos, haverá ressarcimento proporcional ao tempo não utilizado.</p>

  <h3>CLÁUSULA 9 – DA CONFIDENCIALIDADE</h3>

  <p>9.1. As partes manterão sigilo sobre informações estratégicas.</p>

  <p>9.2. O sigilo permanecerá por 2 anos após o término.</p>

  <h3>CLÁUSULA 10 – DOS DIREITOS AUTORAIS</h3>

  <p>10.1. O CONTRATANTE declara possuir direitos sobre os conteúdos.</p>

  <p>10.2. A CONTRATADA não se responsabiliza por uso indevido.</p>

  <p>10.3. O CONTRATANTE indenizará eventuais prejuízos.</p>

  <br />
  <br />

  <p style="text-align: right;">
    {{empresa.cidade}} - {{empresa.estado}}, {{contrato.data_atual}}.
  </p>

  <br />
  <br />
  <br />

  ${BLOCO_ASSINATURAS}
`;

const VARIAVEIS = [
  {
    grupo: 'Cliente',
    itens: [
      { label: 'Nome do cliente', value: '{{cliente.nome}}' },
      { label: 'CPF/CNPJ', value: '{{cliente.cnpj}}' },
      { label: 'E-mail', value: '{{cliente.email}}' },
      { label: 'Telefone', value: '{{cliente.telefone}}' },
      { label: 'Endereço', value: '{{cliente.endereco}}' },
      { label: 'Cidade', value: '{{cliente.cidade}}' },
      { label: 'Estado', value: '{{cliente.estado}}' },
      { label: 'Inscrição Municipal', value: '{{cliente.inscricao_municipal}}' },
      { label: 'Inscrição Estadual', value: '{{cliente.inscricao_estadual}}' },
    ],
  },
  {
    grupo: 'Empresa',
    itens: [
      { label: 'Nome fantasia', value: '{{empresa.nome}}' },
      { label: 'Razão social', value: '{{empresa.razao_social}}' },
      { label: 'CNPJ', value: '{{empresa.cnpj}}' },
      { label: 'E-mail', value: '{{empresa.email}}' },
      { label: 'Telefone', value: '{{empresa.telefone}}' },
      { label: 'Endereço', value: '{{empresa.endereco}}' },
      { label: 'Cidade', value: '{{empresa.cidade}}' },
      { label: 'Estado', value: '{{empresa.estado}}' },
    ],
  },
  {
    grupo: 'Plano de Mídia',
    itens: [
      { label: 'Nome do plano', value: '{{plano.nome}}' },
      { label: 'Valor do plano', value: '{{plano.valor}}' },
      { label: 'Duração', value: '{{plano.duracao}}' },
      { label: 'Unidade', value: '{{plano.unidade}}' },
    ],
  },
  {
    grupo: 'Pedido',
    itens: [
      { label: 'Código do pedido', value: '{{pedido.codigo}}' },
      { label: 'Data de início', value: '{{pedido.data_inicio}}' },
      { label: 'Data de fim', value: '{{pedido.data_fim}}' },
      { label: 'Status do pedido', value: '{{pedido.status}}' },
      { label: 'Qtd. de anúncios', value: '{{pedido.quantidade_anuncios}}' },
      { label: 'Valor base', value: '{{pedido.valor_base}}' },
      { label: 'Valor total', value: '{{pedido.valor_total}}' },
      { label: 'Desconto', value: '{{pedido.desconto}}' },
      { label: 'Qtd. de parcelas', value: '{{pedido.quantidade_parcelas}}' },
      { label: 'Valor da parcela', value: '{{pedido.valor_parcela}}' },
    ],
  },
  {
    grupo: 'Serviço',
    itens: [
      { label: 'Nome do serviço', value: '{{servico.nome}}' },
      { label: 'Descrição do serviço', value: '{{servico.descricao}}' },
    ],
  },
  {
    grupo: 'Equipamentos / Outdoors',
    itens: [
      { label: 'Lista de equipamentos', value: '{{equipamentos.lista}}' },
      { label: 'Quantidade de equipamentos', value: '{{equipamentos.quantidade}}' },
      { label: 'Locais de veiculação', value: '{{equipamentos.locais}}' },
      // ✅ A TABELA é montada pelo BACKEND no render. Insere num parágrafo isolado.
      { label: '📋 Tabela de equipamentos (auto)', value: BLOCO_EQUIPAMENTOS, html: true },
    ],
  },
  {
    grupo: 'Contrato',
    itens: [
      { label: 'Data atual', value: '{{contrato.data_atual}}' },
      { label: 'Código do contrato', value: '{{contrato.codigo}}' },
    ],
  },
  {
    grupo: 'Blocos Prontos',
    itens: [
      { label: '✍️ Bloco de Assinaturas', value: BLOCO_ASSINATURAS, html: true },
      { label: '💰 Resumo Financeiro', value: BLOCO_RESUMO_FINANCEIRO, html: true },
    ],
  },
];

// ==========================================
// PÁGINA PRINCIPAL
// ==========================================
export default function ModeloContratos() {
  const [contratos,       setContratos]       = useState([]);
  const [searchTerm,      setSearchTerm]      = useState('');
  const [showModal,       setShowModal]       = useState(false);
  const [currentContrato, setCurrentContrato] = useState(null);
  const [loading,         setLoading]         = useState(true);

  // ── Fetch ──
  const fetchContratos = async () => {
    try {
      setLoading(true);

      const res = await api.get('/contract-templates');

      setContratos(res.data);
    } catch (error) {
      toast.error('Erro ao carregar os modelos de contrato.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContratos();
  }, []);

  // ── Handlers ──
  const handleSave = async (data) => {
    try {
      if (!data.name?.trim()) {
        toast.error('Informe o nome do modelo.');
        return;
      }

      if (!data.htmlContent?.trim()) {
        toast.error('O conteúdo do contrato não pode ficar vazio.');
        return;
      }

      const payload = {
        name: data.name,
        description: data.description,
        htmlContent: data.htmlContent,
        isActive: data.isActive,
      };

      if (data.id) {
        await api.put(`/contract-templates/${data.id}`, payload);
        toast.success('Modelo de contrato atualizado com sucesso!');
      } else {
        await api.post('/contract-templates', payload);
        toast.success('Modelo de contrato cadastrado com sucesso!');
      }

      await fetchContratos();

      setShowModal(false);
      setCurrentContrato(null);
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao salvar o modelo de contrato.');
    }
  };

  const handleToggleStatus = async (contrato) => {
    const msg = contrato.isActive
      ? 'Tem certeza que deseja INATIVAR este modelo de contrato?'
      : 'Deseja ATIVAR este modelo de contrato novamente?';

    if (!window.confirm(msg)) return;

    try {
      await api.put(`/contract-templates/${contrato.id}`, {
        name: contrato.name,
        description: contrato.description,
        htmlContent: contrato.htmlContent || contrato.html_content,
        isActive: !contrato.isActive,
      });

      toast.success(`Modelo ${contrato.isActive ? 'inativado' : 'ativado'} com sucesso!`);

      await fetchContratos();
    } catch (error) {
      toast.error('Erro ao alterar o status do modelo.');
    }
  };

  const handleNew = () => {
    setCurrentContrato(null);
    setShowModal(true);
  };

  const handleEdit = (contrato) => {
    setCurrentContrato(contrato);
    setShowModal(true);
  };

  // ── Filtro ──
  const filtered = contratos.filter((contrato) => {
    const term = searchTerm.toLowerCase();

    return (
      contrato.name?.toLowerCase().includes(term) ||
      contrato.description?.toLowerCase().includes(term)
    );
  });

  const formatDate = (date) => {
    if (!date) return '-';

    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <Container fluid className="p-4">

      <PageHeader
        title="Modelos de Contrato"
        buttonLabel="Novo Modelo"
        onButtonClick={handleNew}
      />

      <SearchFilterBar
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchPlaceholder="Buscar modelo por nome ou descrição..."
      />

      <DataTable
        columns={COLUMNS}
        loading={loading}
        emptyMessage="Nenhum modelo de contrato encontrado."
      >
        {filtered.length > 0 && filtered.map((contrato) => (
          <tr key={contrato.id}>
            <td>
              <div className="d-flex align-items-center gap-2">
                <FaFileContract className="text-primary" />
                <strong>{contrato.name}</strong>
              </div>
            </td>

            <td>{contrato.description || '-'}</td>

            <td>{formatDate(contrato.updatedAt || contrato.updated_at)}</td>

            <td>
              {contrato.isActive
                ? (
                  <span className="text-success fw-bold">
                    <FaCheckCircle className="me-1" />
                    Ativo
                  </span>
                )
                : (
                  <span className="text-secondary fw-bold">
                    <FaBan className="me-1" />
                    Inativo
                  </span>
                )}
            </td>

            <td>
              <Button
                variant="warning"
                size="sm"
                className="me-2"
                onClick={() => handleEdit(contrato)}
                title="Editar Modelo"
              >
                <FaEdit />
              </Button>

              <Button
                variant={contrato.isActive ? 'danger' : 'success'}
                size="sm"
                onClick={() => handleToggleStatus(contrato)}
                title={contrato.isActive ? 'Inativar Modelo' : 'Ativar Modelo'}
              >
                {contrato.isActive ? <FaBan /> : <FaCheckCircle />}
              </Button>
            </td>
          </tr>
        ))}
      </DataTable>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        backdrop="static"
      >
        <Modal.Body>
          <ContratoForm
            contrato={currentContrato}
            onSave={handleSave}
            onCancel={() => setShowModal(false)}
          />
        </Modal.Body>
      </Modal>

    </Container>
  );
}

// ==========================================
// FORMULÁRIO
// ==========================================
function ContratoForm({ contrato, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    id: contrato?.id || null,
    name: contrato?.name || '',
    description: contrato?.description || '',
    htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
    isActive: contrato?.id ? contrato.isActive : true,
  });

  useEffect(() => {
    setFormData({
      id: contrato?.id || null,
      name: contrato?.name || '',
      description: contrato?.description || '',
      htmlContent: contrato?.htmlContent || contrato?.html_content || DEFAULT_TEMPLATE,
      isActive: contrato?.id ? contrato.isActive : true,
    });
  }, [contrato]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditorChange = (html) => {
    setFormData((prev) => ({
      ...prev,
      htmlContent: html,
    }));
  };

  return (
    <Card className="border-0">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          {contrato ? 'Editar Modelo de Contrato' : 'Novo Modelo de Contrato'}
        </h5>

        <StatusSwitch
          value={formData.isActive}
          onChange={(v) => setFormData((prev) => ({ ...prev, isActive: v }))}
        />
      </Card.Header>

      <Card.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSave(formData);
          }}
        >
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome do Modelo *</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ex: Contrato Padrão de Veiculação Outdoor"
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Ex: Modelo usado para contratos de mídia externa"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Conteúdo do Contrato *</Form.Label>

            <ContractEditor
              value={formData.htmlContent}
              onChange={handleEditorChange}
            />
          </Form.Group>

          <hr />

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button variant="secondary" onClick={onCancel}>
              <FaTimes className="me-1" />
              Cancelar
            </Button>

            <Button variant="success" type="submit">
              <FaSave className="me-2" />
              Salvar
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

// ==========================================
// EDITOR TIPTAP
// ==========================================

// Extensões customizadas — preservam style inline
const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) =>
          attributes.style ? { style: attributes.style } : {},
      },
    };
  },
});

const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) =>
          attributes.style ? { style: attributes.style } : {},
      },
    };
  },
});

function ContractEditor({ value, onChange }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link.configure({
        openOnClick: false,
      }),
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Table.configure({
        resizable: false,
        HTMLAttributes: {
          style: 'width: 100%; border-collapse: collapse;',
        },
      }),
      TableRow,
      CustomTableHeader, // ✅ preserva style inline
      CustomTableCell,   // ✅ preserva style inline
    ],
    content: value || '',
    onUpdate({ editor }) {
      onChange(editor.getHTML());
    },
  });

  useEffect(() => {
    if (!editor) return;

    const currentHtml = editor.getHTML();

    if (value && value !== currentHtml) {
      editor.commands.setContent(value);
    }
  }, [value, editor]);

  if (!editor) {
    return null;
  }

  // ✅ Recebe o ITEM inteiro (objeto) e diferencia texto de HTML
  const inserirVariavel = (item) => {
    const conteudo = typeof item === 'string' ? item : item.value;
    const isHtml = typeof item === 'object' && item.html;

    if (isHtml) {
      editor
        .chain()
        .focus()
        .insertContent(conteudo, {
          parseOptions: { preserveWhitespace: false },
        })
        .run();
    } else {
      editor.chain().focus().insertContent(conteudo).run();
    }
  };

  return (
    <div className="contract-editor-wrapper">
      <Row className="g-0">
        <Col md={9}>
          <div className="contract-toolbar">
            <Button
              type="button"
              variant={editor.isActive('bold') ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().toggleBold().run()}
              title="Negrito"
            >
              <FaBold />
            </Button>

            <Button
              type="button"
              variant={editor.isActive('italic') ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().toggleItalic().run()}
              title="Itálico"
            >
              <FaItalic />
            </Button>

            <Button
              type="button"
              variant={editor.isActive('underline') ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              title="Sublinhado"
            >
              <FaUnderline />
            </Button>

            <Button
              type="button"
              variant={editor.isActive('heading', { level: 2 }) ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
              title="Título"
            >
              Título
            </Button>

            <Button
              type="button"
              variant={editor.isActive('bulletList') ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              title="Lista"
            >
              <FaListUl />
            </Button>

            <Button
              type="button"
              variant={editor.isActive({ textAlign: 'left' }) ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().setTextAlign('left').run()}
              title="Alinhar à esquerda"
            >
              <FaAlignLeft />
            </Button>

            <Button
              type="button"
              variant={editor.isActive({ textAlign: 'center' }) ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().setTextAlign('center').run()}
              title="Centralizar"
            >
              <FaAlignCenter />
            </Button>

            <Button
              type="button"
              variant={editor.isActive({ textAlign: 'right' }) ? 'primary' : 'light'}
              size="sm"
              onClick={() => editor.chain().focus().setTextAlign('right').run()}
              title="Alinhar à direita"
            >
              <FaAlignRight />
            </Button>
          </div>

          <div className="contract-editor">
            <EditorContent editor={editor} />
          </div>
        </Col>

        <Col md={3}>
          <div className="contract-vars">
            <h6 className="fw-bold mb-3">Variáveis disponíveis</h6>

            {VARIAVEIS.map((grupo) => (
              <div key={grupo.grupo} className="mb-3">
                <div className="text-muted fw-bold small mb-2">
                  {grupo.grupo}
                </div>

                <div className="d-grid gap-2">
                  {grupo.itens.map((item) => (
                    <Button
                      key={item.label}
                      type="button"
                      variant={item.html ? 'outline-primary' : 'outline-secondary'}
                      size="sm"
                      className="text-start"
                      onClick={() => inserirVariavel(item)}
                      title={item.html ? 'Insere um bloco pronto' : item.value}
                    >
                      {item.label}
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
}
